// extracted by mini-css-extract-plugin
export default {"container":"Images_container__mJmEm","image":"Images_image__T1i+J"};